module.exports = "span {\n  font-weight: 500; }\n\np {\n  line-height: 20px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/dialogs/alg-email-modal/alg-email-modal.component.scss
// module id = ./src/app/components/dialogs/alg-email-modal/alg-email-modal.component.scss
// module chunks = main